import React, { useState, useEffect, useRef } from 'react';
import CommonGrid from '../../../Components/common/CommonGrid'

import { Container, Row, Col, Button, Table, Form, Dropdown, Badge } from "react-bootstrap";
import { faEye, faPencil, faTrashCan, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import Todolist1 from "../../../assets/images/todolist1.png"; 

import { toast } from 'react-toastify';

import { CallApi } from '../../../Components/common/CommonFunctions.js';

const AllStation = () => {

    const isMounted = useRef(false);
    const gridRef = useRef(null);
    // const [gridData, setGridData] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    const fetchAssignUser = async () => {
        setIsLoading(true)
        CallApi({
            endPoint: 'uld-settings/stations',
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    // setGridData(innerData);
                    const transData = {
                        ...innerData[0],
                        address_count: innerData[0].handlers?.filter(st => st.status === 1)?.length,
                    };
                    loadDetails(transData)
                } else {
                    toast.error(data.response_msg);
                }
                setIsLoading(false)
            },
            onError: (msg) => toast.error(msg)
        });
    };

    useEffect(() => {
        if (isMounted.current) return;
        // fetchAssignUser();
        isMounted.current = true;
    }, []);

    const datafields = [
        { name: 'station_id', type: 'string' },
        { name: 'station_code', type: 'string' },
        { name: 'address_count', type: 'string' },
        { name: 'handlers', type: 'string' },
        { name: 'station_name', type: 'string' },
    ]

    const columns = [
        { text: 'Stations', filtertype: 'textbox', datafield: 'station_code', width: '40%', cellclassname: 'frcl', },
        {
            text: 'Handlers', filtertype: 'textbox', datafield: 'address_count', width: '50%', cellclassname: 'frcl',
            cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;">' + rowdata.handlers.length + '</div>';
            }
        },
    ];

    const gridData = {
        Tab: 0,
        TabName: [], // {Active: [], Archives: []}
        Token: `SAToken`,
        page: 'allstn',
        EndPoint: 'uld-settings/stations',
        Datafields: datafields,
        Columns: columns,
        nested: false,
        rowClick: true,
        Options: {
            height: 700,
            pageSize: 10,
            pagesizeoptions: ['10', '20', '50', '100'],
            selectionmode: 'checkbox',
        },
    }

    // useEffect(() => {

    //     if (gridRef.current) {

    //         if (gridData) {
    //             const localData = gridData.map((item, index) => ({
    //                 ...item,
    //                 address_count: item.handlers?.filter(st => st.status === 1)?.length, // item.station_addresses.length
    //                 // Address: item.station_addresses // ?.join(', ')Join the address array into a string
    //             }));
    //             const source = {
    //                 datatype: 'json',
    //                 id: '1',
    //                 datafields: [
    //                     { name: 'station_id', type: 'string' },
    //                     { name: 'station_code', type: 'string' },
    //                     { name: 'address_count', type: 'string' },
    //                     { name: 'handlers', type: 'string' },
    //                     { name: 'station_name', type: 'string' },
    //                 ],
    //                 localdata: localData,
    //             };

    //             const dataAdapter = new window.$.jqx.dataAdapter(source);
    //             // console.log('localdata', source.localdata)
    //             const columns = [
    //                 // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
    //                 { text: 'Stations', filtertype: 'textbox', datafield: 'station_code', width: '40%', cellclassname: 'frcl', },
    //                 { text: 'Handlers', filtertype: 'textbox', datafield: 'address_count', width: '50%', cellclassname: 'frcl', },
    //             ];

    //             const gridOptions = {
    //                 width: '100%',
    //                 source: dataAdapter,
    //                 columns: columns,
    //                 autoheight: true,
    //                 sortable: true,
    //                 altrows: false,
    //                 enabletooltips: true,
    //                 editable: false,
    //                 selectionmode: 'singlerow',
    //                 pageable: true,
    //                 pageSize: 10,
    //                 pagerButtonsCount: 5,
    //                 pagerMode: 'advanced',
    //                 filterable: true,
    //                 filterrowheight: 45,
    //                 showfilterrow: true,
    //                 rowsheight: 42,
    //                 columnsheight: 45,

    //             };

    //             window.$(gridRef.current).jqxGrid(gridOptions);
    //             window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

    //             // window.$(gridRef.current).jqxDragDrop({
    //             //     // dragTarget: gridRef.current,
    //             //     // dropAction: "default",
    //             //     revert: true,
    //             // });

    //             // let draggedIndex = null;

    //             // window.$(gridRef.current).on("dragStart", (event) => {
    //             //     draggedIndex = window.$(gridRef.current).jqxGrid("getselectedrowindex");
    //             // });

    //             // window.$(gridRef.current).on("dragEnd", (event) => {
    //             //     if (draggedIndex === null) return;

    //             //     const dropPosition = event.args.position;
    //             //     const toIndex = window.$(gridRef.current).jqxGrid("getrowboundindex", dropPosition);

    //             //     if (draggedIndex === toIndex) return;

    //             //     setGridData((prev) => {
    //             //         const updated = [...prev];
    //             //         const movedRow = updated.splice(draggedIndex, 1)[0];
    //             //         updated.splice(toIndex, 0, movedRow);
    //             //         return updated;
    //             //     });

    //             //     draggedIndex = null;
    //             // });

    //             window.$(gridRef.current).on('rowclick', (event) => {
    //                 // console.log('event', event);
    //                 const args = event.args.row.bounddata;
    //                 // console.log('args', args);
    //                 const sendRowId = gridData;
    //                 loadDetails(args);
    //             });
    //             window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
    //                 window.$(row).on('mouseover', () => {
    //                     window.$(row).addClass('row-hover');
    //                 });
    //                 window.$(row).on('mouseout', () => {
    //                     window.$(row).removeClass('row-hover');
    //                 });
    //             });
    //             // row selection by checkbox
    //             window.$(gridRef.current).on('rowselect', (event) => {

    //                 if (event.args.row) {

    //                     const selectedRow = event.args.row.id;

    //                     if (!gridSelect.includes(selectedRow)) {
    //                         setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
    //                     }
    //                     setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
    //                 } else {
    //                     // Handle "Select All" case
    //                     // const allIds = planData.map(row => row.booking_id);
    //                     // console.log("All IDs:", allIds);
    //                     // setGridSelect(allIds);
    //                     console.log("Select All triggered");
    //                 }
    //             });
    //             // console.log('ggg', gridSelect);
    //             window.$(gridRef.current).on('rowunselect', (event) => {
    //                 if (event.args.row) {
    //                     const unselectedRowId = event.args.row.id;
    //                     setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
    //                 } else {
    //                     setGridSelect([]);
    //                 }
    //             });
    //             // End row selection 

    //         } else {
    //             const columns = [
    //                 { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
    //                 { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
    //             ];
    //         }
    //     }
    // }, [gridData]);

    const loadDetails = (data) => {
        // console.log(data);
        
        CallApi({
            endPoint: 'uld-settings/stations-details',
            payload: {station_id: data.station_id},
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    
                    setSelectedRowData(innerData)
                } else {
                    toast.error(data.response_msg);
                }
                setIsLoading(false)
            },
            onError: (msg) => toast.error(msg)
        });
        // setSelectedRowData(data)
    }

    return (
        <>
            {isLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {/* {console.log('selectedRowData', selectedRowData)} */}
            <section className="requestlist-sec allst-bg pt-3 mb-2">
                <div className="request-head">
                    <h2>
                        <span>
                            <img src={Todolist1} alt="" />
                        </span>
                        All Stations
                    </h2>
                </div>
                <div className="allstation-wrap">
                    <div className="allstation-tble">
                        <div className="table-responsive">
                            <CommonGrid GD={gridData} onSwitch={''} detailsData={loadDetails} />
                            {/* <div ref={gridRef} className='staion_grid' ></div> */}
                            {/* <Table>
                                <thead>
                                    <tr>
                                        <th>Station</th>
                                        <th>Handlers</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {" "}
                                            <Form>
                                                <Form.Control type="text" placeholder="" />
                                            </Form>{" "}
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>AMS</td>
                                        <td>
                                            <span className="amsdiv">
                                                <span className="usicn">
                                                    <FontAwesomeIcon icon={faUser} />
                                                </span>
                                                6
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>BRU</td>
                                        <td>
                                            <span className="amsdiv">
                                                <span className="usicn">
                                                    <FontAwesomeIcon icon={faUser} />
                                                </span>
                                                13
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>AMS</td>
                                        <td>
                                            <span className="amsdiv">
                                                <span className="usicn">
                                                    <FontAwesomeIcon icon={faUser} />
                                                </span>
                                                6
                                            </span>
                                        </td>
                                    </tr>

                                </tbody>
                            </Table> */}
                        </div>
                    </div>
                    {console.log('selectedRowData',selectedRowData)}
                    <div className="ams-warp">
                        <div className="ams-head-div d-flex justify-content-between align-items-center">
                            <div className="ams-head">
                                <h2> {selectedRowData?.station_code} - {selectedRowData?.station_name} </h2>
                            </div>
                            <div className="edit-wrap">
                                <h3>
                                    <span>
                                        <FontAwesomeIcon icon={faPencil} />
                                    </span>
                                    Edit
                                </h3>
                            </div>
                        </div>
                        <div className="station-wrap">
                            <div className="station-div">
                                <ul>
                                    <li>
                                        <span className="std">Station Details</span>
                                        <span>: &nbsp; </span>
                                    </li>
                                    <li>
                                        <span className="std">Handler</span>
                                        <span>: &nbsp; {selectedRowData?.handlerList?.length}</span>
                                    </li>
                                    <li>
                                        <span className="std">Assign Work</span>
                                        <span>: &nbsp; {selectedRowData?.assignWork}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="station-div">
                                <ul>
                                    <li>
                                        <span className="std">Station Code</span>
                                        <span>: &nbsp; {selectedRowData?.stationCode}</span>
                                    </li>
                                    <li>
                                        <span className="std">Location</span>
                                        <span>: &nbsp; {selectedRowData?.cityName}, {selectedRowData?.countryName}</span>
                                    </li>
                                    <li>
                                        <span className="std">Shipment</span>
                                        <span>: &nbsp; </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="handler-list">
                            <div className="hndlr-tbl">
                                <div className="table-responsive">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th colSpan={2}>Handler List</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedRowData?.handlerList?.map((hnd, index) => (
                                                <>
                                                    <tr key={hnd + index}>
                                                        <td>{hnd?.org_Name}</td>
                                                        <td>
                                                            <span className="amsdiv">
                                                                <span className="usicn">
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>
                                                                View
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </>
                                            ))}
                                            {/* <tr>
                                                <td>Handler 1</td>
                                                <td>
                                                    <span className="amsdiv">
                                                        <span className="usicn">
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                        View
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Handler 1</td>
                                                <td>
                                                    <span className="amsdiv">
                                                        <span className="usicn">
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                        View
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Handler 1</td>
                                                <td>
                                                    <span className="amsdiv">
                                                        <span className="usicn">
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                        View
                                                    </span>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AllStation